require.ensure(["./b"], function(require) {
	require("./b").should.be.eql("a");
})


/*****************
 ** WEBPACK FOOTER
 ** ./chunks/runtime/duplicate2.js
 ** module id = 3
 ** module chunks = 1 6
 **/